<app-banner-app [retroSelected]=false></app-banner-app>

<div style="background-color: #DFEAFF;">
    <br>
    <div class="container">
        <br><br><br><br>
        <div class="row contenido">
            <div class="col">
                <div class="textoArriba">
                    <br>
                    <div>
                        <p class="texto2">
                            Para continuar con la compra de tu <br>
                            seguro, es necesario que tengas un<br>
                            inquilino.
                        </p>
                    </div>
                    <img src="./assets/img/callCenter.png" />
                    <div>
                        <p class="texto1">
                            ¡Tranqui! Alguien de nuestro equipo se<br>
                            pondrá en contacto contigo 
                            para resolver<br> tus dudas.
                        </p>
                        <br>
                        <p class="texto2">
                            Si ya tienes un inquilino en mente, te<br>
                            ayudamos a hacer el estudio 
                            financiero sin<br> costo.
                        </p>
                    </div>
                </div>
                <div class="textoAbajo">
                    <img src="./assets/img/callCenter.png" />
                    <div>
                        <p class="texto2">Para continuar con la compra de tu <br>
                            seguro, es necesario que tengas un<br>
                            inquilino.</p>
                    </div>
                </div>
                <br>

                <div class="container tamanioBoton">
                    <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit" 
                    (click)="volverInicio()">
                        Entendido
                    </button>
                </div>
            </div>
        </div>
    </div>

    <br><br><br><br>
    <app-footer-app />

</div>